import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../App/ClientSDK'

import { IApiPerformanceStats, IPerformanceStats } from './IPerformanceStats'
import Transformer from './Transformer'

class Client {
    static getPerformanceStats = (
        from: Moment,
        to: Moment
    ): Promise<IPerformanceStats[]> => {
        return ClientSDK.instance()
            .get(
                'reports/person-performance/' +
                    from.format('YYYY-MM-DD') +
                    '/' +
                    to.format('YYYY-MM-DD')
            )
            .then(
                (
                    response: AxiosResponse<{
                        statistics: IApiPerformanceStats[]
                    }>
                ): IPerformanceStats[] => {
                    return response.data.statistics.map(
                        (data: IApiPerformanceStats) =>
                            Transformer.transform(data)
                    )
                }
            )
    }
}

export default Client
